export const initFavicon = (): void => {
  if (typeof document === 'undefined') return;

  let faviconLink = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
  if (!faviconLink) {
    faviconLink = document.createElement('link');
    faviconLink.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(faviconLink);
  }
  faviconLink.href = '/favicon.ico';
};
